import { RouteComponentProps, Router } from '@reach/router';

import { HubCountersList } from './List';
import { HubCountersParcels } from './Parcels';
import { ApiMonitor } from './ApiMonitor';

interface HubCountersPageProps extends RouteComponentProps {}

export const HubCountersPage: React.FC<HubCountersPageProps> = () => {
  return (
    <Router>
      <HubCountersList path="/hub-counters/list" />
      <HubCountersParcels path="/hub-counters/parcels" />
      <ApiMonitor path="/api-monitor" />
    </Router>
  );
};
